export const HOME_STATUSES = [
    {
        transKey: 'FINANCING.RESIDENCE_INFOS.HOME_STATUS_TYPE.OWN_FREE_AND_CLEAR',
        value: 'OwnFreeAndClear',
    },
    {
        transKey: 'FINANCING.RESIDENCE_INFOS.HOME_STATUS_TYPE.OWN_MOBILE_HOME',
        value: 'OwnMobileHome',
    },
    {
        transKey: 'FINANCING.RESIDENCE_INFOS.HOME_STATUS_TYPE.OTHER',
        value: 'Other',
    },
    {
        transKey: 'FINANCING.RESIDENCE_INFOS.HOME_STATUS_TYPE.OWN_WITH_MORTAGE',
        value: 'OwnWithMortage',
    },
    {
        transKey: 'FINANCING.RESIDENCE_INFOS.HOME_STATUS_TYPE.PARENTS',
        value: 'Parents',
    },
    {
        transKey: 'FINANCING.RESIDENCE_INFOS.HOME_STATUS_TYPE.RENT',
        value: 'Rent',
    },
    {
        transKey: 'FINANCING.RESIDENCE_INFOS.HOME_STATUS_TYPE.RESERVE_HOUSING',
        value: 'ReserveHousing',
    },
];

export default {
    HOME_STATUSES,
};



// WEBPACK FOOTER //
// ./src/constants/housing.js